import React, { Component, Fragment, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { countEmbeddedFiles } from '../../Templates/functions'
import moment from 'moment'
import Minimalistic from 'react-sortable-tree-theme-minimal';
import SortableTree from 'react-sortable-tree';
import { BuildClock, duplicateInstructionIcon, editInstructionIcon, ManageUsersIcon, previewInstructionIcon, deleteInstructionIcon, ModelViewer } from '../../Templates/icons'
import Dialogue from '../../Templates/Dialogue'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { fetchWorkInstruction } from '../../../util/wi_util';
import { DEFAULT_PREVIEW_IMAGE, fileApiPath, fileKey, fileName, fileUrl } from '../../../util/file_url';
import { LoadingContext } from '../../../LoadingContext';
import { online } from '../../../util/user_util';
import JSZip from 'jszip';


class WISummary extends Component {
    state = {
        treeData: this.props.workInstruction.steps || [],
        isOnline: true, // Assume online initially, will be verified
        isDownloaded: false,
        showContextMenu: false,
        contextMenuX: 0,
        contextMenuY: 0
    }

    static contextType = LoadingContext;

    componentDidMount = () => {
      
        let page = document.getElementById("wi-page-content-container")
        page.addEventListener("keydown",this.stopTabScroll)

        // Perform initial checks
        this.performOnlineCheck();
        this.checkCacheStatus(); // Keep cache check

        // Setup polling for online status
        this.onlineCheckInterval = setInterval(this.performOnlineCheck, 10000); // Check every 10 seconds
        
        // Add click listener to close context menu when clicking elsewhere
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount = () => {

        let page = document.getElementById("wi-page-content-container")
        page.removeEventListener("keydown",this.stopTabScroll)

        // Clear the online check interval
        if (this.onlineCheckInterval) {
            clearInterval(this.onlineCheckInterval);
        }
        
        // Remove click listener for context menu
        document.removeEventListener('click', this.handleClickOutside);
    }

    // Function to check backend reachability and update state
    performOnlineCheck = () => {
        online().then(isOnlineResult => {
            // Only update state if the status has changed
            if (this.state.isOnline !== isOnlineResult) {
                this.setState({ isOnline: isOnlineResult });
                // Optional: Re-check cache status if going online, as it might affect download state visibility/logic
                if (isOnlineResult) {
                     this.checkCacheStatus();
                 }
            }
        }).catch(err => {
            console.error("[WISummaryLite] Error during periodic online check:", err);
            // If error occurs, assume offline if not already set
            if (this.state.isOnline) {
                 this.setState({ isOnline: false });
            }
        });
    }

    // Function to check if the WI data is in the runtime cache
    checkCacheStatus = async () => {
        const { workInstruction } = this.props;
        if (!workInstruction || !workInstruction._id) {
            // console.warn('[WISummaryLite Cache Check] Missing workInstruction or _id in props.');
            return;
        }

        if (window.electronAPI && typeof window.electronAPI.checkLocalFilesStatus === 'function') {
            // Electron environment: Fetch latest WI when online, then verify local files against that version
            try {
                let wiForCheck = workInstruction;
                if (this.state.isOnline) {
                    try {
                        const response = await fetchWorkInstruction(workInstruction._id);
                        if (response && response.data && response.data._id === workInstruction._id) {
                            wiForCheck = response.data;
                        }
                    } catch (fetchErr) {
                        console.warn('[WISummaryLite] Failed to fetch latest WI for cache check, using provided WI. Error:', fetchErr?.message);
                    }
                }

                const isFullyCached = await window.electronAPI.checkLocalFilesStatus(wiForCheck);
                console.log(`[WISummaryLite Electron Cache Check] WI: "${wiForCheck.title || 'N/A'}" (ID: ${wiForCheck._id}) | Fully cached on disk: ${isFullyCached}`);
                if (this.state.isDownloaded !== isFullyCached) {
                    this.setState({ isDownloaded: isFullyCached });
                }
            } catch (error) {
                console.error(`[WISummaryLite Electron Cache Check] WI: "${workInstruction.title || 'N/A'}" - Error checking local file status:`, error);
                if (this.state.isDownloaded) {
                    this.setState({ isDownloaded: false });
                }
            }
        } else if ('caches' in window) {
            // Web environment: Check browser Cache Storage API (existing logic)
            // console.warn('[SW Cache Check] Cache Storage API not supported.'); // Original line, seems like a typo for the else if condition
            const cacheName = 'runtime-cache'; 
            const wiDataUrl = `${window.config.getApiBaseUrl()}/api/wip/${workInstruction._id}`;
            try {
                const cache = await caches.open(cacheName);
                const match = await cache.match(wiDataUrl);
                const isCurrentlyDownloaded = !!match;
                console.log(`[SW Cache Check] WI: "${workInstruction.title || 'N/A'}" (ID: ${workInstruction._id}) | Checking URL: ${wiDataUrl} | Found in cache: ${isCurrentlyDownloaded}`);
                if (this.state.isDownloaded !== isCurrentlyDownloaded) {
                    console.log(`[SW Cache Check] WI: "${workInstruction.title || 'N/A'}" (ID: ${workInstruction._id}) | State changing from ${this.state.isDownloaded} to ${isCurrentlyDownloaded}`);
                    this.setState({ isDownloaded: isCurrentlyDownloaded });
                }
            } catch (error) {
                console.error(`[SW Cache Check] WI: "${workInstruction.title || 'N/A'}" (ID: ${workInstruction._id}) - Error checking cache for ${wiDataUrl}:`, error);
                if (this.state.isDownloaded) {
                    this.setState({ isDownloaded: false });
                }
            }
        } else {
            console.warn('[Cache Check] Neither Electron API nor Cache Storage API is available.');
        }
    }

    stopTabScroll=(e)=>{
        console.log("checking key pressed")
        if(e.keyCode == 9){
            e.preventDefault()
        }
    }

    updateContent = (content) => {
        let count = countEmbeddedFiles(content)
        if (count === 0) return content;
        // a space must be added after the content or else the regex expression will return 0 for last index.
        content = `${content} `
        //finds first instance of ![ and sets first index
        let firstIndex = content.search(/!\[/)
        //finds first insteads of .ext] and sets last index
        let lastIndex = content.search(/(:{2})*.]/)
        //replaces content inside of those indices for a clickable button
        let updatedContent = this.replaceContent(content, firstIndex, lastIndex)
        //calls function recursively to continue process with a new string containing a clickable button and remaining str
        return this.updateContent(updatedContent)
    }

    editWorkInstruction = (e, id, release, isAssignable,title) => {
        e.preventDefault()
        if(release && isAssignable ){
           if (window.confirm("The WI you are about to edit is already published and doing so will cause it to be unpublished. Are you sure you want to continue?") == true){
            this.props.selectWorkInstruction(id).then((data) => {
                let url = `/dashboard/model viewer/${id + "~&~" + title}?pdf=${data.workInstruction.isPDFViewer}&view=js`
                this.props.history.push(url)
            })
        }

        } else{
            fetchWorkInstruction(id).then((response) => {
                const workInstructionData = response.data;
                console.log("Fetched directly:", workInstructionData);
                let url = `/dashboard/model viewer/${id + "~&~" + title}?pdf=${workInstructionData.isPDFViewer}&view=js`;
                this.props.history.push(url);
            }).catch(error => {
                console.error("Error fetching work instruction directly:", error);
                alert("Failed to load the work instruction. Please try again.");
            });

        }
    }

    previewWorkInstruction = (e, id) => {
        e.preventDefault()
        this.props.previewWorkInstruction(id).then((data) => {
            let url = `/dashboard/work instructions/preview/${id}?pdf=${data.workInstruction.isPDFViewer}`
            this.props.history.push(url)
        }
        );
    }

    deleteWorkInstruction = (e, id) => {
        e.stopPropagation();
        
        if (this.props.workInstruction.assignees > 0) {
            alert("This Work Instruction has assignees and cannot be deleted.");
            return;
        }
        
        this.setState({ 
            displayingDialogue: true,
            deletingWorkInstructionId: id  // Keep track of the ID of the Work Instruction to be deleted
        });
    }
    
    handleDownloadClick = async () => {
        // Prevent clicking if already downloaded or offline
        if (this.state.isDownloaded || !this.state.isOnline) return;

        // Ensure electronAPI and saveDownloadedFile are available
        if (!window.electronAPI || typeof window.electronAPI.saveDownloadedFile !== 'function') {
            console.error("[WISummaryLite Download] Electron API for saving files is not available.");
            // For web context, rely on service worker caching (current behavior)
            // Optionally, add a user notification here for web if download isn't service-worker based
            if (!('caches' in window)) {
                alert("File download for offline use is not fully supported in this browser environment without service workers or specific Electron integration.");
            }
            // Proceed with fetch-only for potential SW caching if in web and SW is active
            // but for Electron, we should ideally stop if save API is missing.
            // However, to keep existing SW logic path, let's allow fetches.
        }

        const { incrementRequestCount, decrementRequestCount } = this.context;
        const { workInstruction } = this.props;

        if (!workInstruction || !workInstruction._id) {
            console.error("[WISummaryLite Download] Work instruction data is missing.");
            return;
        }

        const baseUrl = window.config.getApiBaseUrl();
        const fetchAndSavePromises = [];

        console.log(`[WISummaryLite Download] Starting download & save process for WI: ${workInstruction.title || 'N/A'}`);
        incrementRequestCount();

        const processFile = async (url, type, filename, modelId = null) => {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    console.warn(`[WISummaryLite Download] Failed to fetch ${url}: ${response.statusText}`);
                    return { success: false, url, error: response.statusText }; // Return status for allSettled
                }
                const data = await response.arrayBuffer(); // Get content as ArrayBuffer

                if (window.electronAPI && typeof window.electronAPI.saveDownloadedFile === 'function') {
                    console.log(`[WISummaryLite Download] Sending ${type} "${filename}" to main process for saving.`);
                    const saveResult = await window.electronAPI.saveDownloadedFile({ type, filename, data, modelId });
                    if (saveResult.success) {
                        console.log(`[WISummaryLite Download] Successfully saved ${type} "${filename}" to ${saveResult.path}`);
                    } else {
                        console.error(`[WISummaryLite Download] Failed to save ${type} "${filename}": ${saveResult.error}`);
                    }
                    return saveResult; // Return save result for allSettled
                } else {
                    // In web context, rely on SW. Log that file was fetched.
                    console.log(`[WISummaryLite Download - Web] Fetched ${type} "${filename}". Relies on Service Worker for caching.`);
                    return { success: true, type: 'webFetch', url }; 
                }
            } catch (error) {
                console.error(`[WISummaryLite Download] Network or processing error for ${url}:`, error);
                return { success: false, url, error: error.message }; // Ensure errors are caught for allSettled
            }
        };

        try {
            // 1. Main WI Data (JSON)
            const wiDataUrl = `${baseUrl}/api/wip/${workInstruction._id}`;
            fetchAndSavePromises.push(processFile(wiDataUrl, 'wiData', `${workInstruction._id}.json`)); // Save as JSON

            // 2. Main PDF (if isPDFViewer)
            if (workInstruction.isPDFViewer && workInstruction.pdfPath) {
                const pdfUrl = fileUrl(workInstruction.pdfPath);
                fetchAndSavePromises.push(processFile(pdfUrl, 'mainPdf', fileName(workInstruction.pdfPath)));
            }

            // 3. Preview Image
            if (workInstruction.preview_img && workInstruction.preview_img !== DEFAULT_PREVIEW_IMAGE) {
                const previewUrl = fileUrl(workInstruction.preview_img);
                fetchAndSavePromises.push(processFile(previewUrl, 'previewImage', fileName(workInstruction.preview_img)));
            }

            // 4. Step Attachments and Models (including child steps)
            if (workInstruction.steps) {
                // Recursive function to process step and its children
                const processStepAttachments = (step) => {
                    // Process current step's attachments
                    if (step.attachments && step.attachments.length > 0) {
                        step.attachments.forEach(attachment => {
                            let apiUrlPath = '';
                            let fileType = 'attachment';
                            let modelDirId = null;

                            if ((attachment.temp_model_id && (attachment.fileExtension === 'obj' || attachment.fileExtension === 'glb'))) {
                                modelDirId = attachment.temp_model_id;
                                apiUrlPath = `/api/models/obj/${modelDirId}/${attachment.path}`;
                                fileType = 'model';
                            }
                            else if (attachment._id && (attachment.fileExtension === 'obj' || attachment.fileExtension === 'glb')) {
                                modelDirId = attachment._id;
                                apiUrlPath = `/api/models/obj/${modelDirId}/${attachment.path}`;
                                fileType = 'model';
                            }
                            else if (attachment.path) {
                                apiUrlPath = fileApiPath(fileKey(attachment));
                                // fileType is already 'attachment'
                            }

                            if (apiUrlPath) {
                                const fullUrl = `${baseUrl}${apiUrlPath}`;
                                fetchAndSavePromises.push(processFile(fullUrl, fileType, attachment.path, modelDirId));
                            }
                        });
                    }

                    // Recursively process child steps
                    if (step.children && step.children.length > 0) {
                        step.children.forEach(childStep => {
                            processStepAttachments(childStep); // Recursive call
                        });
                    }
                };

                // Process all top-level steps (and their children recursively)
                workInstruction.steps.forEach(step => {
                    processStepAttachments(step);
                });
            }

            // 5. PDF Highlight Attachments (if any)
            if (workInstruction.isPDFViewer) {
                let wiDetailsForHighlights = null;
                try {
                    const wiResp = await fetchWorkInstruction(workInstruction._id);
                    wiDetailsForHighlights = (wiResp && wiResp.data) ? wiResp.data : workInstruction;
                } catch (e) {
                    wiDetailsForHighlights = workInstruction; // Fallback to existing data
                }

                const highlights = (wiDetailsForHighlights && (wiDetailsForHighlights.PDFViewerHighlights || wiDetailsForHighlights.pdfViewerHighlights)) || [];
                if (Array.isArray(highlights) && highlights.length > 0) {
                    highlights.forEach(highlight => {
                        if (Array.isArray(highlight.attachments) && highlight.attachments.length > 0) {
                            highlight.attachments.forEach(attachment => {
                                // Try both flattened and nested Attachment shapes
                                const attPath = attachment.path || (attachment.Attachment && attachment.Attachment.path);
                                const attExt = ((attachment.fileExtension || (attachment.Attachment && attachment.Attachment.fileExtension) || '') + '').toLowerCase();
                                let modelDirId = attachment.temp_model_id || attachment._id || (attachment.Attachment && attachment.Attachment._id) || null;

                                if (!attPath) return;

                                let apiUrlPath = '';
                                let fileType = 'attachment';

                                if (attExt === 'obj' || attExt === 'glb') {
                                    fileType = 'model';
                                    if (modelDirId) {
                                        apiUrlPath = `/api/models/obj/${modelDirId}/${attPath}`;
                                    } else {
                                        // If we cannot determine a model ID directory, skip to avoid misplacing file
                                        return;
                                    }
                                } else {
                                    const attId = attachment._id || (attachment.Attachment && attachment.Attachment._id);
                                    if (!attId) return;
                                    apiUrlPath = fileApiPath(`${attId}/${attPath}`);
                                }

                                if (apiUrlPath) {
                                    const fullUrl = `${baseUrl}${apiUrlPath}`;
                                    fetchAndSavePromises.push(processFile(fullUrl, fileType, attPath, modelDirId));
                                }
                            });
                        }
                    });
                }
            }

            console.log(`[WISummaryLite Download] Waiting for ${fetchAndSavePromises.length} files to be processed (fetched/saved)...`);
            const results = await Promise.allSettled(fetchAndSavePromises);
            results.forEach(result => {
                if (result.status === 'fulfilled' && result.value.success) {
                    // Optionally log individual success further if needed
                } else if (result.status === 'fulfilled' && !result.value.success) {
                    console.warn(`[WISummaryLite Download] A file operation failed or was skipped:`, result.value);
                } else if (result.status === 'rejected') {
                    console.error(`[WISummaryLite Download] A file operation promise was rejected:`, result.reason);
                }
            });

            console.log(`[WISummaryLite Download] All file processing attempts settled for WI: ${workInstruction.title || 'N/A'}.`);

            // Introduce a small delay before checking cache status
            const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
            await delay(250); // Increased delay slightly to allow file system operations to complete

            await this.checkCacheStatus(); // Re-check status after attempting to save all files

        } catch (error) {
            console.error(`[WISummaryLite Download] Error during overall download process for ${workInstruction.title || 'N/A'}:`, error);
            await this.checkCacheStatus(); // Still check cache status
        } finally {
            decrementRequestCount();
            console.log(`[WISummaryLite Download] Download & save process finished for ${workInstruction.title || 'N/A'}, loader hidden.`);
        }
    }

    // Handle right-click on download icon to show context menu
    handleRightClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Only show context menu if online
        if (!this.state.isOnline) {
            return;
        }
        
        // Calculate position to prevent menu from going off screen
        const menuWidth = 250; // Approximate width of context menu
        const menuHeight = 50; // Approximate height of context menu
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        
        let x = e.clientX;
        let y = e.clientY;
        
        // Adjust if menu would go off right edge
        if (x + menuWidth > windowWidth) {
            x = windowWidth - menuWidth - 10;
        }
        
        // Adjust if menu would go off bottom edge
        if (y + menuHeight > windowHeight) {
            y = windowHeight - menuHeight - 10;
        }
        
        this.setState({
            showContextMenu: true,
            contextMenuX: x,
            contextMenuY: y
        });
    }

    // Handle click outside context menu to close it
    handleClickOutside = (e) => {
        if (this.state.showContextMenu && !e.target.closest('.download-context-menu')) {
            this.setState({ showContextMenu: false });
        }
    }

    // Download all necessary files as a .zip
    handleDownloadAsZip = async () => {
        this.setState({ showContextMenu: false });
        
        const { incrementRequestCount, decrementRequestCount } = this.context;
        const { workInstruction } = this.props;

        if (!workInstruction || !workInstruction._id) {
            console.error("[WISummaryLite Zip Download] Work instruction data is missing.");
            alert("Unable to download: Work instruction data is missing.");
            return;
        }

        const baseUrl = window.config.getApiBaseUrl();
        const zip = new JSZip();
        
        console.log(`[WISummaryLite Zip Download] Starting zip creation for WI: ${workInstruction.title || 'N/A'}`);
        incrementRequestCount();

        try {
            // Helper function to add file to zip with auth token
            const addFileToZip = async (url, zipPath) => {
                try {
                    // Get JWT token from localStorage for authenticated requests
                    const token = localStorage.getItem('jwtToken');
                    const headers = {};
                    if (token) {
                        // Backend expects "Bearer <token>" format
                        headers['Authorization'] = `Bearer ${token}`;
                    }
                    
                    const response = await fetch(url, { headers });
                    if (!response.ok) {
                        console.warn(`[WISummaryLite Zip Download] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
                        return false;
                    }
                    const data = await response.blob();
                    zip.file(zipPath, data);
                    console.log(`[WISummaryLite Zip Download] Added to zip: ${zipPath}`);
                    return true;
                } catch (error) {
                    console.error(`[WISummaryLite Zip Download] Error fetching ${url}:`, error);
                    return false;
                }
            };

            // 1. Add main WI data as JSON - CRITICAL FILE
            const wiDataUrl = `${baseUrl}/api/wip/${workInstruction._id}`;
            try {
                const token = localStorage.getItem('jwtToken');
                const headers = {};
                if (token) {
                    // Backend expects "Bearer <token>" format
                    headers['Authorization'] = `Bearer ${token}`;
                }
                
                const response = await fetch(wiDataUrl, { headers });
                if (!response.ok) {
                    throw new Error(`Failed to fetch WI data: ${response.status} ${response.statusText}`);
                }
                const wiData = await response.json();
                zip.file('work-instruction.json', JSON.stringify(wiData, null, 2));
                console.log(`[WISummaryLite Zip Download] ✓ Added main WI JSON data`);
            } catch (error) {
                console.error(`[WISummaryLite Zip Download] ERROR: Could not fetch main WI data:`, error);
                alert(`Error: Could not fetch work instruction data. ${error.message}`);
                throw error; // Stop the download process if main WI data can't be fetched
            }

            // 2. Add main PDF (if isPDFViewer)
            if (workInstruction.isPDFViewer && workInstruction.pdfPath) {
                const pdfUrl = fileUrl(workInstruction.pdfPath);
                await addFileToZip(pdfUrl, `pdf/${fileName(workInstruction.pdfPath)}`);
            }

            // 3. Add preview image
            if (workInstruction.preview_img && workInstruction.preview_img !== DEFAULT_PREVIEW_IMAGE) {
                const previewUrl = fileUrl(workInstruction.preview_img);
                await addFileToZip(previewUrl, `preview/${fileName(workInstruction.preview_img)}`);
            }

            // 4. Add all preview images (if multiple)
            if (Array.isArray(workInstruction.previewImages) && workInstruction.previewImages.length > 0) {
                for (const previewImg of workInstruction.previewImages) {
                    // Entries are attachment records; older ones may be keys.
                    const previewKey = previewImg && (typeof previewImg === 'string' ? previewImg : fileKey(previewImg));
                    if (previewKey && previewKey !== DEFAULT_PREVIEW_IMAGE) {
                        const previewUrl = fileUrl(previewKey);
                        await addFileToZip(previewUrl, `preview-images/${fileName(previewKey)}`);
                    }
                }
            }

            // 5. Process step attachments and models (including child steps recursively)
            if (workInstruction.steps && workInstruction.steps.length > 0) {
                const processStepAttachments = async (step, stepPath = '') => {
                    if (step.attachments && step.attachments.length > 0) {
                        for (let i = 0; i < step.attachments.length; i++) {
                            const attachment = step.attachments[i];
                            let apiUrlPath = '';
                            let zipPath = '';

                            // Determine if this is a model or regular attachment
                            const isModelFile = (attachment.fileExtension === 'obj' || attachment.fileExtension === 'glb');
                            
                            if (isModelFile) {
                                // Model file
                                const modelDirId = attachment.temp_model_id || attachment._id;
                                if (modelDirId && attachment.path) {
                                    apiUrlPath = `/api/models/obj/${modelDirId}/${attachment.path}`;
                                    zipPath = `models/${modelDirId}/${attachment.path}`;
                                    
                                    const fullUrl = `${baseUrl}${apiUrlPath}`;
                                    await addFileToZip(fullUrl, zipPath);
                                }
                            } else if (attachment.path) {
                                // Regular attachment
                                apiUrlPath = fileApiPath(fileKey(attachment));
                                zipPath = `attachments/${stepPath ? stepPath + '/' : ''}${attachment.path}`;
                                
                                const fullUrl = `${baseUrl}${apiUrlPath}`;
                                await addFileToZip(fullUrl, zipPath);
                            }

                            // Also check for texture_config to download associated textures
                            if (isModelFile && attachment.texture_config) {
                                try {
                                    const textureConfig = typeof attachment.texture_config === 'string' 
                                        ? JSON.parse(attachment.texture_config) 
                                        : attachment.texture_config;
                                    
                                    if (textureConfig.textureFiles && Array.isArray(textureConfig.textureFiles)) {
                                        const modelDirId = attachment.temp_model_id || attachment._id;
                                        for (const textureFile of textureConfig.textureFiles) {
                                            if (textureFile.filename) {
                                                const textureUrl = `${baseUrl}/api/models/obj/${modelDirId}/${textureFile.filename}`;
                                                const textureZipPath = `models/${modelDirId}/${textureFile.filename}`;
                                                await addFileToZip(textureUrl, textureZipPath);
                                            }
                                        }
                                    }
                                } catch (e) {
                                    console.warn('[WISummaryLite Zip Download] Failed to parse texture_config:', e);
                                }
                            }
                        }
                    }

                    // Recursively process child steps
                    if (step.children && step.children.length > 0) {
                        for (let j = 0; j < step.children.length; j++) {
                            const childStep = step.children[j];
                            const childTitle = (childStep.title || `child-${j}`).replace(/[^a-z0-9]/gi, '_');
                            const childPath = stepPath ? `${stepPath}/${childTitle}` : childTitle;
                            await processStepAttachments(childStep, childPath);
                        }
                    }
                };

                // Process all top-level steps
                for (let i = 0; i < workInstruction.steps.length; i++) {
                    const step = workInstruction.steps[i];
                    const stepTitle = (step.title || `step-${i}`).replace(/[^a-z0-9]/gi, '_');
                    await processStepAttachments(step, stepTitle);
                }
            }

            // 6. Process PDF highlight attachments (if any)
            if (workInstruction.isPDFViewer) {
                let wiDetailsForHighlights = null;
                try {
                    const wiResp = await fetchWorkInstruction(workInstruction._id);
                    wiDetailsForHighlights = (wiResp && wiResp.data) ? wiResp.data : workInstruction;
                } catch (e) {
                    wiDetailsForHighlights = workInstruction;
                }

                const highlights = (wiDetailsForHighlights && (wiDetailsForHighlights.PDFViewerHighlights || wiDetailsForHighlights.pdfViewerHighlights)) || [];
                if (Array.isArray(highlights) && highlights.length > 0) {
                    for (const highlight of highlights) {
                        if (Array.isArray(highlight.attachments) && highlight.attachments.length > 0) {
                            for (const attachment of highlight.attachments) {
                                const attPath = attachment.path || (attachment.Attachment && attachment.Attachment.path);
                                const attExt = ((attachment.fileExtension || (attachment.Attachment && attachment.Attachment.fileExtension) || '') + '').toLowerCase();
                                let modelDirId = attachment.temp_model_id || attachment._id || (attachment.Attachment && attachment.Attachment._id) || null;

                                if (!attPath) continue;

                                let apiUrlPath = '';
                                let zipPath = '';

                                if (attExt === 'obj' || attExt === 'glb') {
                                    if (modelDirId) {
                                        apiUrlPath = `/api/models/obj/${modelDirId}/${attPath}`;
                                        zipPath = `pdf-highlights/models/${modelDirId}/${attPath}`;
                                        
                                        const fullUrl = `${baseUrl}${apiUrlPath}`;
                                        await addFileToZip(fullUrl, zipPath);
                                    }
                                } else {
                                    const attId = attachment._id || (attachment.Attachment && attachment.Attachment._id);
                                    if (!attId) continue;
                                    apiUrlPath = fileApiPath(`${attId}/${attPath}`);
                                    zipPath = `pdf-highlights/attachments/${attPath}`;
                                    
                                    const fullUrl = `${baseUrl}${apiUrlPath}`;
                                    await addFileToZip(fullUrl, zipPath);
                                }
                            }
                        }
                    }
                }
            }

            // 7. Process nested/linked WIs (from WipGroup and PDF highlight links)
            const linkedWIMap = new Map(); // Use Map to avoid duplicates
            
            // 7a. Collect WIs from WipGroup
            if (workInstruction.WipGroup && Array.isArray(workInstruction.WipGroup) && workInstruction.WipGroup.length > 0) {
                for (const linkedWI of workInstruction.WipGroup) {
                    if (linkedWI.wip_ID && !linkedWI.del) {
                        linkedWIMap.set(linkedWI.wip_ID, linkedWI.title);
                    }
                }
            }
            
            // 7b. Collect WIs from PDF highlight Anno_id links (for PDF WIs)
            if (workInstruction.isPDFViewer) {
                let wiDetailsForLinks = null;
                try {
                    const wiResp = await fetchWorkInstruction(workInstruction._id);
                    wiDetailsForLinks = (wiResp && wiResp.data) ? wiResp.data : workInstruction;
                } catch (e) {
                    wiDetailsForLinks = workInstruction;
                }
                
                const highlights = (wiDetailsForLinks && (wiDetailsForLinks.PDFViewerHighlights || wiDetailsForLinks.pdfViewerHighlights)) || [];
                if (Array.isArray(highlights) && highlights.length > 0) {
                    for (const highlight of highlights) {
                        // Check if Anno_id contains a WI link (format: "someId~~~~WILINK:{json}")
                        if (highlight.Anno_id && highlight.Anno_id.includes('~~~~WILINK:')) {
                            try {
                                const parts = highlight.Anno_id.split('~~~~WILINK:');
                                if (parts.length > 1) {
                                    const wiLinkData = JSON.parse(parts[1]);
                                    if (wiLinkData.wip_ID && wiLinkData.title) {
                                        linkedWIMap.set(wiLinkData.wip_ID, wiLinkData.title);
                                        console.log(`[WISummaryLite Zip Download] Found PDF highlight linked WI: ${wiLinkData.title} (${wiLinkData.wip_ID})`);
                                    }
                                }
                            } catch (parseErr) {
                                console.warn(`[WISummaryLite Zip Download] Failed to parse WI link from Anno_id: ${highlight.Anno_id}`, parseErr);
                            }
                        }
                    }
                }
            }
            
            // 7c. Download all unique linked WIs (with their PDFs and essential files)
            if (linkedWIMap.size > 0) {
                console.log(`[WISummaryLite Zip Download] Found ${linkedWIMap.size} unique linked WI(s) to download`);
                for (const [wipId, title] of linkedWIMap.entries()) {
                    try {
                        const linkedWiResp = await fetchWorkInstruction(wipId);
                        if (linkedWiResp && linkedWiResp.data) {
                            const linkedWiData = linkedWiResp.data;
                            const sanitizedTitle = (linkedWiData.title || title || wipId).replace(/[^a-z0-9]/gi, '_');
                            const linkedWiFolder = `linked-wis/${sanitizedTitle}_${wipId}`;
                            
                            // Save the WI JSON
                            zip.file(`${linkedWiFolder}/work-instruction.json`, JSON.stringify(linkedWiData, null, 2));
                            console.log(`[WISummaryLite Zip Download] ✓ Added linked WI JSON: ${linkedWiData.title}`);
                            
                            // If it's a PDF WI, download the PDF file
                            if (linkedWiData.isPDFViewer && linkedWiData.pdfPath) {
                                const pdfUrl = fileUrl(linkedWiData.pdfPath);
                                const pdfAdded = await addFileToZip(pdfUrl, `${linkedWiFolder}/pdf/${fileName(linkedWiData.pdfPath)}`);
                                if (pdfAdded) {
                                    console.log(`[WISummaryLite Zip Download] ✓ Added linked WI PDF: ${linkedWiData.pdfPath}`);
                                }
                            }
                            
                            // Download preview image if not default
                            if (linkedWiData.preview_img && linkedWiData.preview_img !== DEFAULT_PREVIEW_IMAGE) {
                                const previewUrl = fileUrl(linkedWiData.preview_img);
                                await addFileToZip(previewUrl, `${linkedWiFolder}/preview/${fileName(linkedWiData.preview_img)}`);
                            }
                        }
                    } catch (e) {
                        console.warn(`[WISummaryLite Zip Download] Failed to fetch linked WI ${wipId}:`, e);
                    }
                }
            }

            // Generate the zip file
            console.log(`[WISummaryLite Zip Download] Generating zip file...`);
            console.log(`[WISummaryLite Zip Download] Total files added to zip: ${Object.keys(zip.files).length}`);
            
            const zipBlob = await zip.generateAsync({ 
                type: 'blob',
                compression: "DEFLATE",
                compressionOptions: { level: 6 }
            });
            
            const zipSizeMB = (zipBlob.size / (1024 * 1024)).toFixed(2);
            console.log(`[WISummaryLite Zip Download] Zip file size: ${zipSizeMB} MB`);
            
            // Create download link
            const url = window.URL.createObjectURL(zipBlob);
            const link = document.createElement('a');
            link.href = url;
            const sanitizedTitle = (workInstruction.title || 'work-instruction').replace(/[^a-z0-9]/gi, '_');
            link.download = `${sanitizedTitle}_${workInstruction._id}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            console.log(`[WISummaryLite Zip Download] ✓ Zip file download initiated successfully: ${link.download}`);
            alert(`Work Instruction package downloaded successfully!\n\nFile: ${link.download}\nSize: ${zipSizeMB} MB\nFiles: ${Object.keys(zip.files).length}`);

        } catch (error) {
            console.error(`[WISummaryLite Zip Download] Error creating zip:`, error);
            alert("An error occurred while creating the download package. Please try again.");
        } finally {
            decrementRequestCount();
        }
    }

    generateContent = (content) => {
        content = this.updateContent(content)

        let contentNode = (
            <div style={{ marginLeft: ".625em" }}
                id="step-preview-content"
                contentEditable={false}
                dangerouslySetInnerHTML={{ __html: content }}
            >
            </div>
        )
        return contentNode
    }

    parseDate = (MSSQLDate) => {
        let creationTimestampMs = Number(MSSQLDate);
        let formattedDate = moment.utc(creationTimestampMs).local(true).format("MM/DD/YYYY hh:mm A");
        return formattedDate;
    }

    renderImage = () => {
        return <img id="summary-thumbnail" src={fileUrl(this.props.workInstruction.preview_img || DEFAULT_PREVIEW_IMAGE)} alt="work instruction preview" />
    }

    render() {
        let workInstruction = this.props.workInstruction
        let { release, isAssignable } = workInstruction

        const rawPublicationPage = this.props.workInstruction.publication_page || {}
        // Handle both direct publication_page structure and nested publicationPagePayload structure
        const publicationPage = rawPublicationPage.publicationPagePayload || rawPublicationPage

        const treeData = this.state.treeData
        // const assignedUsers = this.props.users.filter(user => user.assignments.some(assignment => assignment.wip_id === workInstruction.wip_id))
        return <div id="wi-page-content-container" className="flex-column shadow" style={{ position: 'relative' }}>
            {
                this.state.displayingDialogue ? (
                    <Dialogue
                        alert={
                            this.props.workInstruction.assignees > 0
                            ? "This Work Instruction has assignees and cannot be deleted."
                            : "You are about to delete a Work Instruction, this action cannot be undone. Would you like to proceed with the deletion?"
                        }
                        confirmAction={() => {
                            if (this.state.deletingWorkInstructionId) {
                                this.props.deleteWorkInstruction(this.state.deletingWorkInstructionId);
                                this.setState({ displayingDialogue: false, deletingWorkInstructionId: null });
                            }
                        }}
                        cancel={() => this.setState({ displayingDialogue: false, deletingWorkInstructionId: null })}
                    />
                ) : null
            }


            <div id="wi-page-container-header" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
                <h3 className="break-word" style={{ margin: 0 }}>{workInstruction.title}</h3>
                {/* Logic revised: Show checkmark if downloaded (online/offline). Show download only if online AND not downloaded. */}
                {this.state.isDownloaded ? (
                    // Always show green check if downloaded
                    <FontAwesomeIcon 
                        icon={faCheckCircle} 
                        style={{
                            cursor: 'default',
                            fontSize: '1.5em',
                            position: 'absolute',
                            right: '1em',
                            color: '#28a745' // Always green when downloaded
                        }} 
                        title={this.state.isDownloaded ? "Work Instruction downloaded for offline use" : "Download for offline use"}
                    />
                ) : ( this.state.isOnline && (
                    // Only show download icon if online AND not downloaded
                    <FontAwesomeIcon 
                        icon={faDownload} 
                        style={{
                            cursor: 'pointer',
                            fontSize: '1.5em',
                            position: 'absolute',
                            right: '1em',
                            color: 'inherit'
                        }} 
                        onClick={this.handleDownloadClick}
                        onContextMenu={this.handleRightClick}
                        title={"Download for offline use (right-click for .zip download)"}
                    />
                ))}
                
                {/* Context Menu for Download Options */}
                {this.state.showContextMenu && (
                    <div 
                        className="download-context-menu"
                        style={{
                            position: 'fixed',
                            top: this.state.contextMenuY,
                            left: this.state.contextMenuX,
                            backgroundColor: 'white',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                            zIndex: 10000,
                            minWidth: '200px'
                        }}
                    >
                        <div
                            style={{
                                padding: '12px 16px',
                                cursor: 'pointer'
                            }}
                            onClick={this.handleDownloadAsZip}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                        >
                            Download as ZIP
                        </div>
                    </div>
                )}
            </div>


            
            <div className="" style={{overflowY:"scroll", height:"100%"}}>
                <div className="flex-justify-center" style={{ padding: ".625em 0" }}>
                    {this.renderImage()}
                </div>
                <div id="toc-p-wrapper" className="max-height FontSize16">
                    {/* {assignedUsers.length > 0 ? <p className="underline" style={{ margin: ".5em" }}>Assigned Users</p> : null } */}
                    {/* {assignedUsers.length > 0 ? assignedUsers.map(user => {{
                            return <li key={user._id}>{`${user.name} ${user.role}`}</li>
                        }}) : null} */}
                    <p style={{ margin: ".5em", textDecoration: "underline" }}>Publication Page</p>
                    <ul id="summary-publication-info" style={{ margin: "1em" }}>
                        {publicationPage ?
                            <Fragment>
                                <li key={`WI-Summary DocNum`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Document Number: ${publicationPage.docNum || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary Created On`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Created On: ${this.parseDate(this.props.workInstruction.creation_date)}`}</h3>
                                </li>
                                <li key={`WI-Summary Created By`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Created By: ${publicationPage.createdBy || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary Modified-On`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Modified On: ${this.parseDate(this.props.workInstruction.modified_date) || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary info-checks-requirement`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Requires Info Page Checks: ${this.props.workInstruction.require_info_checks ? "Yes" : "No"}`}</h3>
                                </li>
                                <li key={`WI-Summary rescission-date`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Recission Date: ${this.parseDate(publicationPage.rescissionDate) || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary identification-classification id-class`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Identification / Classification: ${publicationPage.identificationAndClassification || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary system`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`System: ${publicationPage.system || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary identification-classification subsystem`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Subsystem: ${publicationPage.subSystem || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary Subject`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Subject: ${publicationPage.subject || "N/A"}`}</h3>
                                </li>
                                <li key="WI-Summary References" id="step-preview-description">
                                    <h3 id="summary-publication-category">References: </h3>
                                    <ul id="summary-publication-group">
                                        {(publicationPage.references && publicationPage.references.length > 0) ? 
                                            publicationPage.references.map((item, index) => {
                                                return <li key={index} id="summary-publication-item">{item}</li>
                                            }) : <li id="summary-publication-item">N/A</li>}
                                    </ul>
                                </li>
                                <li key="WI-Summary Figures" id="step-preview-description">
                                    <h3 id="summary-publication-category">Figures: </h3>
                                    <ul id="summary-publication-group">
                                        {(publicationPage.figures && publicationPage.figures.length > 0) ? 
                                            publicationPage.figures.map((item, index) => {
                                                return <li key={index} id="summary-publication-item">{item}</li>
                                            }) : <li id="summary-publication-item">N/A</li>}
                                    </ul>
                                </li>
                                {/* <li key="WI-Summary Tables" id="step-preview-description">
                                    <h3 id="summary-publication-category">Tables: </h3>
                                    <ul id="summary-publication-group">
                                        {publicationPage.tables.map(item => {
                                            return <li id="summary-publication-item">{item}</li>
                                        }) || "N/A"}
                                    </ul>
                                </li> */}
                                <li key="WI-Summary Enclosures" id="step-preview-description">
                                    <h3 id="summary-publication-category">Enclosures: </h3>
                                    <ul id="summary-publication-group">
                                        {(publicationPage.enclosures && publicationPage.enclosures.length > 0) ? 
                                            publicationPage.enclosures.map((item, index) => {
                                                return <li key={index} id="summary-publication-item">{item}</li>
                                            }) : <li id="summary-publication-item">N/A</li>}
                                    </ul>
                                </li>
                            </Fragment>
                            : <div style={{ margin: ".5m" }}> A publication page has not been created yet</div>}
                    </ul>
                    <p style={{ margin: "1em", textDecoration: "underline" }}>Table of Contents</p>
                    <ul id="summary-toc" style={{ height: "inherit" }}>

                        {this.props.workInstruction.steps.length > 0 ?
                            <SortableTree
                            id="testtree"
                                treeData={this.props.workInstruction.steps}
                                onChange={treeData => this.setState({ treeData:this.props.workInstruction.steps })}
                                canDrag={() => false}
                                canDrop={() => false}
                                key={({ node }) => node._id}
                                generateNodeProps={({ node, path }) => ({
                                    // onClick: () => this.props.selectStep(node, path),
                                    // className: this.props.currentStep === node ? 'selected-container' : null
                                })}
                                getNodeKey={({ node }) => node._id}
                                theme={Minimalistic}
                                searchQuery={""}
                                searchFocusOffset={0}
                                style={{ width: '100%', overflowY:"unset!important"}}
                                rowHeight={36}
                                searchFinishCallback={matches =>
                                    this.setState({
                                        searchFoundCount: matches.length,
                                        searchFocusIndex:
                                            matches.length > 0 ? 0 % matches.length : 0,
                                    })
                                }
                            />
                            : <div style={{ margin: ".3125em" }}> There are no steps saved on this work instruction</div>}
                    </ul>
                </div>
                          {(!release || (release && isAssignable)) && (
                <div 
                    id="wi-summary-action-overlay" 
                    className="clickable"
                    style={{
                        position: 'absolute',
                        bottom: '20px', 
                        left: '50%', 
                        transform: 'translateX(-50%)', 
                        zIndex: 10,
                        backgroundColor: '#081f5f',
                        padding: '10px 100px',
                        borderRadius: '5px',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        boxShadow: '0px 2px 5px rgba(0,0,0,0.2)',
                        whiteSpace: 'nowrap',
                    }}
                    onClick={(e) => this.editWorkInstruction(e, this.props.workInstruction._id, release=false, isAssignable=false, this.props.workInstruction.title)}
                >
                    <p style={{ marginRight: ".625em", fontSize:"18px", marginBottom: 0, color: 'white' }}>Load Selected Work Instruction</p>

                </div>
            )}
            </div>
            {/* Fixed Model Viewer Button Overlay - Placed outside scrollable content, visibility tied to condition */} 
  
        </div>
    }
}

export default withRouter(WISummary)